$('document').ready(function () {


    if (document.getElementById('admin')) {

        // ===================================================

        function addEvCheckbox(item) {
            item.change(function () {
                data ={
                    id:$(this).val(),
                    method: $(this).is(':checked')?"add":"remove",
                    type: $(this).attr("data-type")
                }
                postRequest(data, "/carousel");
            });
        }



        function postRequest(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                    type: 'POST',
                }
            ).done(function (result) {
                var answer = result.answer;
                d.resolve(answer);
            }).fail(d.reject);
            return d.promise();
        }

        function deleteRequest(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                     type: 'DELETE'
                }
            ).done(function (result) {
                var answer = result.answer;
                d.resolve(answer);
            }).fail(d.reject);
            return d.promise();
        }


        $(".first-inp").select2({
            placeholder: 'SAP Module'
        });

        $(".second-inp").select2({
            placeholder: 'SAP skills',
            allowClear: true
        });


        function eventOnSearchBySkills(data) {
            var options1 = [];
            var options2 = {};

            data.forEach(function(item, i) {
                var option1;
                option1 = new Option(item['name'],item['id']);
                options2[item['id']] = [];

                item["parameters"].forEach(function(item2, j) {
                    var option2 = [];
                    if (item2["name"] != "Other") {
                        option2 = new Option(item2['name'],item2['id']);
                        options2[item['id']].push(option2);
                    }
                })
                options1.push(option1);
            });

            $(".first-inp").append(options1);
            $(".first-inp").on("change", function () {
                var firstVal = $(this).val();
                var options = [];
                if(firstVal){
                    firstVal.forEach(function(item, i) {

                        options=options.concat(options2[item]);
                    });
                }
                $(".second-inp").html("").append(options);
            });

        }
        var category = {data: ["SAP"]};

        $.when(postRequest(category, "/api/get/skills/all"))
            .done(function (answer) {
                var data = answer[0]['category_type'];
                eventOnSearchBySkills(data);
            });

        // ==================================================


        function hideMenu() {
            $(".btn-menu").removeClass("active");

            $(".side-bar").animate({left: "-345px"},
                {
                    duration: 500,
                    complete: function _completeCallback() {
                        $('body').animate({scrollTop: 0}, 400);
                    }
                });
        }

        $(".btn-menu").click(function () {
            if (!$(this).hasClass("active")) {
                $(this).addClass("active");
                $(".side-bar").show().animate({left: "0"}, 500);
            } else {
                hideMenu();
            }
        });

        $(".side-content").click(function () {
            if ($(".btn-menu").hasClass("active")) {
                hideMenu();
            }
        });

        $(".side-bar a").click(function () {
            if ($(".btn-menu").hasClass("active") && $(this).attr("href") != "#edit-text") {
                hideMenu();
            }
        });

        //======current year for all footers======
        $('#year').text((new Date).getFullYear());
// ===============================approve suggest========================================

        $("#Suggestions .suggestRow").click(function (e) {
            var target = $(e.target);

            if (target.is("input")) {
                var data = {
                    suggest_id: e.target.getAttribute('data-suggest_id')
                };
                setData(data, '/suggest/submit')
            }
        });


        //===================== send color =======================
        var curretBtn;

        $('.colorpicker').colpick({
            onShow: function (colpkr) {
                curretBtn = $(this);
                $(colpkr).fadeIn(500);
                return false;
            },
            onHide: function (colpkr) {
                $(colpkr).fadeOut(500);
                return false;
            },
            onChange: function (hsb, hex, rgb) {
                var form = $('form[data-id=' + curretBtn.attr("data-id") + ']');
                form.find('.color').css('backgroundColor', '#' + hex).removeClass('hidden');
                form.find('.color-default').addClass('hidden');
            },

            onSubmit: function (hsb, hex) {
                var data = {
                    value: "#" + hex,
                    name: curretBtn.attr("data-name"),
                    page_name: curretBtn.attr("data-page-name")
                };
                setData(data, "/admin/manage/set");
                $(".colpick").fadeOut(500);
            }
        });


        //====== side bar on the admin panel======
        $('#admin .side-bar .panel a').on('click', function (e) {

            if (!$(this).attr("data-toggle")) {
                var href = e.target.href.split('#');


                var id = href[href.length - 1];
                $(".side-content .item-box").removeClass("active");
                $(".side-content").find("#" + id).addClass("active");


                $('#admin .side-bar .panel a').removeClass('active');
                $(this).addClass("active");
            }
        });

        //====== EmployersCandidates search======

        $("#admin .search form").submit('click', function (e) {
            e.preventDefault();
            var data = $(this).serializeArray()[0];
        });

        //======default field value======

        function setData(data, route) {
            $.ajax({
                headers: {
                    'X-CSRF-TOKEN': window.Laravel.csrfToken
                },
                url: route,
                data: data,
                dataType: 'json',
                type: 'POST'
            }).done(function (result) {
                if (route == "/suggest/submit") {

                    var answer = result.answer;
                    $("#Suggestions .suggestRow input[data-suggest_id=" + data.suggest_id + "]").prop("checked", answer);
                }
            })
        };

        //======send email for change======
        function handler(e) {
            e.preventDefault();
            var self = $(this);

            var target = $(e.target);

            if (target.is("a")) {
                var defaultText = target.children('.default-value').text();
                $(this).find('.text').val(defaultText);
            }

            if (target.is("button")) {
                var formData;
                if (self.hasClass('email-data')) {
                    formData = {
                        last_email: self.find("input[name='lastEmail']").val(),
                        new_email: self.find("input[name='newEmail']").val()
                    };
                    if (formData) {
                        $.when(getData(formData, "/change_email"))
                            .done(function (answer) {
                                if (answer !== "ok") {
                                    self.find(".error").html(answer);
                                }
                            });
                    }
                }
                if ($(this).hasClass('change-form')) {
                    formData = {
                        user_email: self.find("input[name='user_email']").val(),
                    };
                    if (formData) {
                        $.when(getData(formData, " /reset_password"))
                            .done(function (answer) {
                                if (answer !== "ok") {
                                    self.find(".error").html(answer);
                                }
                            });
                    }
                }

                if ($(this).hasClass('change')) {
                    formData = {
                        name: self.find("textarea").attr("name"),
                        value: self.find("textarea").val(),
                        page_name: self.find("textarea").attr("data-page-name")
                    };
                    if (formData) {
                        $.when(getData(formData, "/admin/manage/set"))
                            .done(function (answer) {
                                if (answer !== "ok") {
                                    self.find(".error").html(answer);
                                }
                            });
                    }
                }
            }
        }

        $("#admin .change-form").click(handler);
        $("#admin .change").click(handler);
        $("#admin .email-data").click(handler);

        //======send image======
        function sendImg(e) {
            e.preventDefault();
            var el = $(this);
            var avatar = new FormData;
            var file = el.find('.select').prop('files')[0];
            if (file) {
                avatar.append("avatar", file);
                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: "/page/image/upload",
                    contentType: false,
                    processData: false,
                    data: avatar,
                    type: 'POST',
                    success: function (result) {
                        if (result.path) {
                            el.find('.img-new').attr("src", "/" + result.path.replace(/\\/g, "/"));
                            el.find('.img-default').addClass('hidden');
                            el.find('.img-new').removeClass('hidden');
                            var data = {
                                value: result.path.replace(/\\/g, "/"),
                                name: el.attr("data-name"),
                                page_name: el.attr("data-page-name")
                            };
                            setData(data, "/admin/manage/set");
                        }
                    }
                });
            }
        }


        $("#admin .image-date").submit(sendImg);


        //======send png======
        function sendPdf(e) {
            e.preventDefault();

            var el = $(this);
            var pdf = new FormData;
            var file = (el.find('.select').prop('files')[0]);
            if (file.name.split('.')[1] == "pdf") {
                pdf.append("pdf", file);

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: "/page/pdf/upload",
                    contentType: false,
                    processData: false,
                    data: pdf,
                    type: 'POST',
                    success: function (result) {
                        if (result.path) {
                            el.find('.new-pdf').children("object").attr("data", "/" + result.path.replace(/\\/g, "/"));
                            el.find('.default-pdf').addClass('hidden');
                            el.find('.new-pdf').removeClass('hidden');
                            var data = {
                                value: result.path.replace(/\\/g, "/"),
                                name: el.attr("data-name"),
                                page_name: el.attr("data-page-name")
                            };
                            setData(data, "/admin/manage/set");
                        }
                    }
                });
            }
        }


        $("#admin .pdf-date").submit(sendPdf);

        //======default pdf======

        function setPdf(e) {
            var target = e.target;
            var nameBtn = target.getAttribute('name');
            if (nameBtn === "default") {
                var el = $(this);
                var src, def, current;
                def = '.default-pdf';
                current = '.new-pdf';
                src = el.find(def).children("object").attr("data").replace('/', "");

                var data = {
                    value: src,
                    name: el.attr("data-name"),
                    page_name: el.attr("data-page-name")
                };

                el.find(def).removeClass('hidden');
                el.find(current).addClass('hidden');
                setData(data, "/admin/manage/set");
            }
        }

        $("#admin .pdf-date").click(setPdf);

        //======default image and color======
        function setDefault(e) {

            var target = e.target;
            var nameBtn = target.getAttribute('name');
            if (nameBtn === "default") {
                var el = $(this);
                var src, def, current;
                if ($(this).hasClass('image-date')) {
                    src = el.find('.img-default').attr("src").replace('/', "");
                    def = '.img-default';
                    current = '.img-new';
                } else {
                    src = el.find('.color-default').css('background');
                    def = '.color-default';
                    current = '.color';
                }
                var data = {
                    value: src,
                    name: el.attr("data-name"),
                    page_name: el.attr("data-page-name")
                };
                el.find(def).removeClass('hidden');
                el.find(current).addClass('hidden');
                setData(data, "/admin/manage/set");
            }
        }

        $("#admin .image-date").click(setDefault);
        $("#admin .color-date").click(setDefault);

//====================================search===================================
        function showError(errorField, content, paginator) {
            $(errorField + ' .server-error').show();
            content.html("");
            paginator.pagination('destroy');
        }

        function hideError(errorField) {
            $(errorField + ' .server-error').hide();
        }

//========================for mustache ==================
        function renderMustache(info, conLoad, file, contOnPage, id) {
            var deferred = $.Deferred();
            conLoad.load(file + id + '', function () {
                var template = $(id).html();
                var output = Mustache.render(template, info);
                contOnPage.html(output);
                deferred.resolve(true);
            });
            return deferred.promise();
        }

        function transformData(data) {
            return {
                data: data.map(function (data) {
                    return data
                })
            }
        }

        //=====================================render data after requests==========================


        function DetermDuration(arrData) {
            var time = {};

            var dateLength = arrData.dates[0].Data.length;
            var lastDate, firstDate;
            if (dateLength) {
                lastDate = arrData.dates[0].Data[dateLength - 1].data;
                firstDate = arrData.dates[0].Data[0].data;
                time.duration = moment(firstDate).from(moment(lastDate), true);
                time.startDate = dateLength ? moment(firstDate).format('MMM DD, YYYY') : "Date is not specified";
            } else {
                time.duration = "Date is not specified";
                time.startDate = "Date is not specified"
            }
            return time
        }

        function renderProject(arrData) {
            if (arrData.length) {
                hideError("#ProjectsReview");
                var data = [];
                for (var i = 0; i < arrData.length; i++) {
                    var time = DetermDuration(arrData[i]);

                    data[i] = {
                        launchedDate: moment(arrData[i].job.created_at).format('MMM DD, YYYY'),
                        img: arrData[i].employer_img,
                        positionDescription: arrData[i].job.position_description,
                        company: arrData[i].job.employer.company_name,
                        SAPskills: arrData[i].sap_skills ? arrData[i].sap_skills.join(" ,") : "Date is not specified",
                        start: time.startDate,
                        duration: time.duration,
                        scope: arrData[i].scope ? arrData[i].scope : "Date is not specified",
                        budgetMin: arrData[i].job.budget_range_min,
                        budgetMax: arrData[i].job.budget_range_max,
                        prId:arrData[i].job.id,
                        carousel:arrData[i].carousel?"checked":""

                    };
                }
                var info = transformData(data);
                $.when(renderMustache(info, $("#templ-prodj"), "/templates/admin-page/renderForSearch.html", $("#projects"), '#project')).done(function (answer) {
                    if (answer) {
                        addPaginator($("#admin #projects .pr-item"), $('#admin #ProjectsReview .pagination'), "projects-");
                    }
                });


                $.when(renderMustache(info, $("#templ-prodj"), "/templates/admin-page/renderForSearch.html", $("#employers-list2"), '#project2')).done(function (answer) {
                    if (answer) {
                        addPaginator($("#admin #employers-list2 .pr-itemy"), $('#admin #Employers2 .pagination'), "employers2-");
                        addEvCheckbox($("#Employers2 .forCarousel"));
                    }
                });
            } else {
                showError("#ProjectsReview", $("#projects"), $("#admin #ProjectsReview .pagination"));
            }
        }

        function checkCount(countSkills, allInfo) {
            for (var j = 0; j < allInfo.length; j++) {
                if (countSkills === allInfo[j].count) {
                    return true;
                }
            }
            return false;
        }
        function renderEmpForRemoving(allInfo, global_count) {
            hideError('#EmployersR');
            var data = [];
            var noData = "not_indicated";
            for (var j = 0; j < allInfo.length; j++) {
                var projects=[];
                if(allInfo[j].projects.length){
                    for (var i = 0; i < allInfo[j].projects.length; i++) {
                        projects.push(allInfo[j].projects[i].project_scope)
                    }
                }

                    data.push({
                        img: allInfo[j].user.img_src,
                        created: moment(allInfo[j].created_at).format('MMM DD, YYYY'),
                        name: allInfo[j].company_name,
                        address: allInfo[j].user.city,
                        state: allInfo[j].user.state ? "State: " + allInfo[j].user.state : "",
                        country: allInfo[j].user.country.name,
                        postCode: allInfo[j].post_code?allInfo[j].post_code:noData,
                        location: allInfo[j].head_office_address?allInfo[j].head_office_address:noData,
                        website: allInfo[j].website ? allInfo[j].website : noData,
                        aboutUs: allInfo[j].about_us,
                        user_id: allInfo[j].id,
                        projects:projects.length? projects.join(', '):noData
                    });
            }
            if (data.length) {
                var info = transformData(data);
                $.when(renderMustache(info, $("#templ-employer"), "/templates/admin-page/renderForSearch.html", $("#employers-listR"), '#employer3')).done(function (answer) {
                    if (answer) {
                        addBtnEvent2("employer-");
                    }
                });
            }
        }


        function renderCandForRemoving(allInfo, global_count) {
            hideError('#CandidatesR');
            var data = [];
            for (var j = 0; j < allInfo.length; j++) {
                data.push({
                    created: moment(allInfo[j].created_at).format('MMM DD, YYYY'),
                    logo: "/" + allInfo[j].user.img_src,
                    name: allInfo[j].user.first_name +" "+allInfo[j].user.last_name,
                    address: allInfo[j].user.country.name,
                    summary: allInfo[j].summary,
                    user_id: allInfo[j].id,
                });
            }
            if (data.length) {
                var info = transformData(data);
                $.when(renderMustache(info, $("#templ-candidate"), "/templates/admin-page/renderForSearch.html", $("#candidates-listR"), '#candidate3')).done(function (answer) {
                    if (answer) {
                        addBtnEvent1("candidate-");
                    }
                });
            }
        }

        function addBtnEvent1(role) {
            $("#Removal #CandidatesR .delete").click(function () {
                var user_id =$(this).attr("data-user-id");
                var date ={
                    user_id:[user_id]
                };
                $.when(deleteRequest(date, "/manage/delete"))
                    .done(function (answer) {
                        if(answer=="ok"){
                            $("#Removal ."+role+user_id).fadeOut(100);
                        }
                    });
            })
        }

        function addBtnEvent2(role) {
            $("#Removal #EmployersR .delete").click(function () {
                var user_id =$(this).attr("data-user-id");
                var date ={
                    user_id:[user_id]
                };
                $.when(deleteRequest(date, "/manage/delete"))
                    .done(function (answer) {
                        if(answer=="ok"){
                            $("#Removal ."+role+user_id).fadeOut(100);
                        }
                    });
            })
        }
        // ========================================================================================
        function renderEmpByNames(allInfo) {
            hideError('#Employers');
            var data = [];
            for (var j = 0; j < allInfo.length; j++) {
                if (allInfo[j].user_type == "Employer") {
                    data.push({
                        img: allInfo[j].photo,
                        name: allInfo[j].company_name + (allInfo[j].contact_name ? " (" + allInfo[j].contact_name + ")" : ""),
                        address: allInfo[j].address.city,
                        state: allInfo[j].address.state ? "State: " + allInfo[j].address.state : "",
                        country: allInfo[j].address.country.name,
                        postCode: allInfo[j].user_object.post_code,
                        location: allInfo[j].user_object.head_office_address,
                        website: allInfo[j].user_object.website ? allInfo[j].user_object.website : ".disabled",
                        aboutUs: allInfo[j].user_object.about_us
                    });
                }
            }
            if (data.length) {
                var info = transformData(data);
                $.when(renderMustache(info, $("#templ-employer"), "/templates/admin-page/renderForSearch.html", $("#employers-list"), '#employer')).done(function (answer) {
                    if (answer) {
                        addPaginator($("#admin #employers-list .panel-body"), $('#admin #Employers .pagination'), "employers-");
                    }
                });
            } else {
                showError('#Employers', $("#admin #employers-list"), $('#admin #Employers .pagination'));
            }
        }

        function renderCandByName(arrData, count) {
            hideError('#Candidates');
            var data = [];
            for (var i = 0; i < arrData.length; i++) {
                if (arrData[i].user_type == "Candidate") {
                    if (count != arrData[i].count && count != -1) {
                        break;
                    }
                    var num = Math.floor(Math.random() * (1000 - 1)) + 1;
                    data.push({
                        created: moment(arrData[i].created_at.date).format('MMM DD, YYYY'),
                        logo: "/" + arrData[i].photo,
                        name: arrData[i].name,
                        address: arrData[i].address.country.name,
                        sapSkills: arrData[i].skills.sap_skills.join(', '),
                        consultingSkills: arrData[i].skills.consulting_skills.join(', '),
                        position: arrData[i].skills.position_skills.join(', '),
                        summary: arrData[i].user_object.summary,
                        data: JSON.stringify(arrData[i].dates),
                        uniqueId: arrData[i].user_object.user_id + "" + arrData[i].id + num,
                        userId: arrData[i].user_object.user_id,
                        budgetMin: arrData[i].user_object.landed_rate_min,
                        budgetMax: arrData[i].user_object.landed_rate_max,
                        carousel:arrData[i].carousel?"checked":""
                    });
                }
            }
            if (data.length) {
                var info = transformData(data);
                $.when(renderMustache(info, $("#templ-candidate"), "/templates/admin-page/renderForSearch.html", $("#candidates-list"), '#candidate')).done(function (answer) {
                    if (answer) {
                        addPaginator($("#admin #candidates-list .panel-body"), $('#admin #Candidates .pagination'), "candidate-");
                        init();

                    }
                });



                $.when(renderMustache(info, $("#templ-candidate"), "/templates/admin-page/renderForSearch.html", $("#candidates-list2"), '#candidate2')).done(function (answer) {
                    if (answer) {
                        addPaginator($("#admin #candidates-list2 .cand-item"), $('#admin #Candidates2 .pagination'), "candidate2-");
                        addEvCheckbox($("#Candidates2 .forCarousel"));
                        init();

                    }
                });
            } else {
                showError('#Candidates', $("#admin #candidates-list"), $('#admin #Candidates .pagination'));
            }
        }


//===========btnSearch===========================

        $('#searchNameBtn').click(function (e) {
            e.preventDefault();
            var data = {name: $.trim($("#searchName").val())};
            $.when(getData(data, "/search/project/name"))
                .done(function (answer) {
                    renderProject(answer);
                });
        });

        $('#searchSkillsBtn').click(function (e) {
            e.preventDefault();
            if ($("#searchSkills").val()) {
                var data = {skills: $("#searchSkills").val()};
                $.when(getData(data, "/search/project/skill"))
                    .done(function (answer) {
                        renderProject(answer);
                    });
            }
        });

        $(".search-cand-bySkill-form").submit(function (e) {
            e.preventDefault();
            if ($(this).find(".second-inp").val()) {
                var data = {skills: $(this).find(".second-inp").val()};
                $.when(getData(data, "/search/user/skill"))
                    .done(function (answer) {
                        var count = data.skills.length;
                        renderCandByName(answer, count);
                    });
            }
        });

        $(".search-empl-byName-form").submit(function (e) {
            e.preventDefault();
            var data = {name: $(this).find("#byName").val()};
            $.when(getData(data, "/search/user/name"))
                .done(function (answer) {
                    renderEmpByNames(answer);
                });

        });

        $(".search-cand-byName-form").submit(function (e) {
            e.preventDefault();
            var data = {name: $(this).find("#byName").val()};
            $.when(getData(data, "/search/user/name"))
                .done(function (answer) {
                    renderCandByName(answer, -1);
                });
        });

        var data = {name: ""};

        $.when(getData(data, "/search/user/name"))
            .done(function (answer) {
                renderCandByName(answer, -1);
                renderEmpByNames(answer);
            });

        $.when(getData(data, "/search/project/name"))
            .done(function (answer) {
                renderProject(answer);
            });

        //=======================Removal=======================
        var data = {
            from_cache: "off",
            limit: 10,
            offset: 0
        }
        $.when(postRequest(data, "/manage/get/employers"))
            .done(function (answer) {

                    var newData = answer.data;

                    if (newData.length) {
                        renderEmpForRemoving(newData, answer.count);
                        addPaginatorPerPage(answer.count, $("#EmployersR .pagination"),"/manage/get/employers",renderEmpForRemoving)
                        // $('html, body').animate({
                        //     scrollTop: $(".employers_project").offset().top
                        // }, 2000);

                    }
                }
            );

        $.when(postRequest(data, "/manage/get/candidates"))
            .done(function (answer) {

                    var newData = answer.data;

                    if (newData.length) {
                        renderCandForRemoving(newData, answer.count);
                        addPaginatorPerPage(answer.count, $("#CandidatesR .pagination"),"/manage/get/candidates",renderCandForRemoving)
                        // $('html, body').animate({
                        //     scrollTop: $(".employers_project").offset().top
                        // }, 2000);

                    }
                }
            );

//=================request============================

        function getData(data, route) {
            var d = $.Deferred();
            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: route,
                    data: data,
                    dataType: 'json',
                    type: 'POST'
                }
            ).done(function (result) {
                var answer;
                if (result.answer) {
                    answer = result.answer;
                }
                d.resolve(answer);
            }).fail(function (xhr) {
                    var answer;
                    var err = JSON.parse(xhr.responseText);
                    if (err.last_email || err.new_email) {
                        if (err.last_email[0].length && err.new_email[0].length) {
                            answer = err.last_email[0] + "</br>" + err.new_email[0];
                            d.resolve(answer);
                        } else if (err.last_email[0].length) {
                            answer = err.last_email[0];
                            d.resolve(answer);
                        } else if (err.new_email) {
                            answer = err.new_email[0];
                            d.resolve(answer);
                        }
                    }

                    if (err.user_email) {
                        answer = err.user_email[0];
                        d.resolve(answer);
                    }
                    d.reject
                }
            );
            return d.promise();
        }

//=======================pagination=======================

        function addPaginator(item, objPaginator, name) {

            var numItems = item.length;
            var perPage = 6;
            item.slice(perPage).hide();
            objPaginator.pagination({
                items: numItems,
                itemsOnPage: perPage,
                hrefTextPrefix: '#' + name + 'page-',

                onPageClick: function (pageNumber) {
                    var showFrom = perPage * (pageNumber - 1);
                    var showTo = showFrom + perPage;
                    item.hide()
                        .slice(showFrom, showTo).show();
                }
            });

            checkFragment(objPaginator, name);
        }

        function addPaginatorPerPage(global_count, objPaginator, route, func) {

            var numItems = global_count;
            var perPage = 10;
            var displayedPages;
            if (numItems <= perPage) {
                displayedPages = 1;
            } else {
                displayedPages = 3;
            }

            objPaginator.pagination({
                items: numItems,
                itemsOnPage: perPage,
                hrefTextPrefix: '#' + name + 'page-',
                displayedPages: displayedPages,

                onPageClick: function (pageNumber) {
                    var pr_id = $("#search-people").attr("data-pr-id");
                    var offset = perPage * (pageNumber - 1);
                    var count;
                    if (pageNumber * perPage > numItems) {
                        count = numItems % perPage;
                    } else {
                        count = perPage;
                    }
                    var data = {
                        from_cache: "on",
                        limit: count,
                        offset: offset
                    }
                    $.when(postRequest(data, route))
                        .done(function (answer) {
                                var newData = answer.data;
                                if (newData.length) {
                                    func(newData, answer.count);

                                    $('html, body').animate({
                                        scrollTop: $("#CandidatesR").offset().top
                                    }, 2000);

                                }
                            }
                        );
                }
            });

            checkFragment(objPaginator, name);
        }

        function checkFragment(ob, name) {

            var hash = window.location.hash || name + "page-1";
            hash = hash.match(/^#cand-page-(\d+)$/);
            if (hash) {
                ob.pagination("selectPage", parseInt(hash[1]));
            }
        };

        function addFirstPaginator(objPaginator) {
            var numItems = $(".person").length;
            var perPage = 10;
            var displayedPages = 3;

            $(".results_box_people .person").slice(perPage).hide();
            objPaginator.pagination({
                items: numItems,
                itemsOnPage: perPage,
                hrefTextPrefix: '#' + name + 'page-',
                displayedPages: displayedPages,

                onPageClick: function (pageNumber) {
                    var showFrom = perPage * (pageNumber - 1);
                    var showTo = showFrom + perPage;
                    $(".person").hide().slice(showFrom, showTo).show();

                    $('html, body').animate({
                        scrollTop: $(".employers_project").offset().top
                    }, 2000);
                }
            });

            checkFragment(objPaginator, name);
        }

        addFirstPaginator($(".pagination"));

        $(window).bind("popstate", checkFragment);
    }
})
;
